module.exports = __webpack_public_path__ + "static/media/sparkles.006b301a.svg";